import { redirect } from "react-router";
import { createArtistsPageURL } from "#lib/urls";
import { logoutAccount } from "#entities/account";

export async function loader() {
  await logoutAccount();

  return redirect(String(createArtistsPageURL()));
}
